<template>
    <div class="split">
        <div class="left">
            <slot name="left"></slot>
        </div>
        <div class="right">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SplitPage',
}
</script>

<style scoped>
.split {
    height: 100%;
}

.left, .right {
    position: absolute;
    height: 100%;
    width: 50%;
}

.right {
    left: 50%;
}
</style>
